import styled from "styled-components";

export const PhotoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 14px;
  margin-top: 10px;
`;

export const PhotoCard = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid var(--border);
  border-radius: 12px;
  overflow: hidden;
  background: var(--surface-2);

  img {
    width: 100%;
    height: 120px;
    object-fit: cover;
    background: var(--surface);
  }
`;

export const PhotoInfo = styled.div`
  padding: 6px 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;

  .category {
    font-size: 0.7rem;
    font-weight: 700;
    color: var(--accent);
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  .caption {
    font-size: 0.78rem;
    color: var(--text-muted);
  }
`;

export const PhotoToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 4px 6px;
  border-top: 1px solid var(--border);
`;

export const UploadRow = styled.div<{ $dragActive?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 6px;
  padding: 8px;
  border-radius: 10px;
  border: 1.5px dashed
    ${(p) => (p.$dragActive ? "var(--accent)" : "transparent")};
  background: ${(p) =>
    p.$dragActive ? "color-mix(in srgb, var(--accent) 8%, transparent)" : "none"};
  transition: border-color 0.15s ease, background 0.15s ease;
`;

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 14px;
`;
